const WLToastr = {
  install: (Vue, options) => {
    Vue.prototype.$wlToastr = (type, message, title) => {
      Vue.prototype.$toastr(type, Vue.prototype.$sanitize(message), title);
    };
  },
};

export default WLToastr;
